import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { verifyApiResponse } from "@utils/apiResponseHelper";

const initialState = {
  teamMembersLoading: false,
  teamMembersError: false,
  teamMembers: [],
  teamMemberDeleteLoading: false,
  teamMemberDeleteSuccess: false,
  teamMemberDeleteError: false,
  teamMemberSendInviteLoading: false,
  teamMemberSendInviteSuccess: false,
  teamMemberSendInviteError: false,
};

export const teamSharingSlice = createSlice({
  name: "teamSharing",
  initialState,
  reducers: {
    getTeamMebersStart: (state) => ({
      ...state,
      teamMembersLoading: true,
      teamMembersError: false,
      teamMembers: [],
    }),
    getTeamMebersSuccess: (state, action) => ({
      ...state,
      teamMembersLoading: false,
      teamMembersError: false,
      teamMembers: action.payload || [],
    }),
    getTeamMebersFailure: (state) => ({
      ...state,
      teamMembersLoading: false,
      teamMembersError: true,
    }),
    updateTeamMembers: (state, action) => ({
      ...state,
      teamMembers: action.payload,
    }),
    deleteTeamMemberStart: (state) => ({
      ...state,
      teamMemberDeleteLoading: true,
      teamMemberDeleteError: false,
    }),
    deleteTeamMemberSuccess: (state) => ({
      ...state,
      teamMemberDeleteLoading: false,
      teamMemberDeleteError: false,
      teamMemberDeleteSuccess: true,
    }),
    deleteTeamMemberFailure: (state) => ({
      ...state,
      teamMemberDeleteLoading: false,
      teamMemberDeleteError: true,
    }),
    resetDeleteTeamMember: (state) => ({
      ...state,
      teamMemberDeleteLoading: false,
      teamMemberDeleteError: false,
      teamMemberDeleteSuccess: false,
    }),
    sendInviteToTeamMemberStart: (state) => ({
      ...state,
      teamMemberSendInviteLoading: true,
      teamMemberSendInviteError: false,
    }),
    sendInviteToTeamMemberSuccess: (state) => ({
      ...state,
      teamMemberSendInviteLoading: false,
      teamMemberSendInviteError: false,
      teamMemberSendInviteSuccess: true,
    }),
    sendInviteToTeamMemberFailure: (state) => ({
      ...state,
      teamMemberSendInviteLoading: false,
      teamMemberSendInviteError: true,
    }),
    resetInviteToTeamMember: (state) => ({
      ...state,
      teamMemberSendInviteLoading: false,
      teamMemberSendInviteError: false,
      teamMemberSendInviteSuccess: false,
    }),
    resetTeamSharing: () => ({
      ...initialState,
    })
  },
});

export const {
  getTeamMebersStart,
  getTeamMebersSuccess,
  getTeamMebersFailure,
  updateTeamMembers,
  deleteTeamMemberStart,
  deleteTeamMemberSuccess,
  deleteTeamMemberFailure,
  resetDeleteTeamMember,
  sendInviteToTeamMemberStart,
  sendInviteToTeamMemberSuccess,
  sendInviteToTeamMemberFailure,
  resetInviteToTeamMember,
  resetTeamSharing,
} = teamSharingSlice.actions;

export const getTeamMembers = (scorecardId) => (dispatch) => {
  dispatch(getTeamMebersStart());

  apiService.get(`${Constants.API.TEAM_MEMBERS}/${scorecardId}`).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      let ifDataExists = Object.keys(data?.data);
      if (ifDataExists?.length > 0) {
        dispatch(getTeamMebersSuccess(data?.data));
      } else {
        dispatch(getTeamMebersFailure());
      }
    } else {
      dispatch(getTeamMebersFailure());
    }
  }).catch(() => {
    dispatch(getTeamMebersFailure());
  })
};

export const deleteTeamMember = (email, scorecardId) => (dispatch) => {
  dispatch(deleteTeamMemberStart());

  apiService.delete(
    `${Constants.API.TEAM_MEMBERS}/${scorecardId}${Constants.API.DELETE_TEAM_MEMBER}${email}`
  ).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      let ifDataExists = Object.keys(data?.data);
      if (ifDataExists?.length > 0) {
        dispatch(deleteTeamMemberSuccess());
        dispatch(updateTeamMembers(data?.data));
      } else {
        dispatch(deleteTeamMemberFailure());
      }
    } else {
      dispatch(deleteTeamMemberFailure());
    }
  }).catch(() => {
    dispatch(deleteTeamMemberFailure());
  })
}

export const sendInviteToTeamMember = (payload) => (dispatch) => {
  dispatch(sendInviteToTeamMemberStart());

  apiService.post(`${Constants.API.TEAM_SHARE}`, payload).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      let ifDataExists = Object.keys(data?.data);
      if (ifDataExists?.length > 0) {
        dispatch(sendInviteToTeamMemberSuccess());
        dispatch(updateTeamMembers(data?.data));
      } else {
        dispatch(sendInviteToTeamMemberFailure());
      }
    } else {
      dispatch(sendInviteToTeamMemberFailure());
    }
  }).catch(() => {
    dispatch(sendInviteToTeamMemberFailure());
  })
}

export default teamSharingSlice.reducer;
